import { gql } from 'graphql-request'

export const REMOVE_ROLE = gql`
  mutation RemoveRole($id: Int!) {
    removeRole(id: $id) {
      message
    }
  }
`
